import React, { useEffect, useState, useRef } from "react";
import { Box } from "@chakra-ui/react";
import Confetti from "react-confetti";

interface ConfettiBackgroundProps {
  duration?: number; // animation duration in ms
  initialPieces?: number; // starting number of pieces
  frozenPieces?: number; // number of pieces to freeze
}

export const ConfettiBackground: React.FC<ConfettiBackgroundProps> = ({
  duration = 3000,
  initialPieces = 100,
  frozenPieces = 30,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isAnimating, setIsAnimating] = useState(true);
  const [size, setSize] = useState({ width: 0, height: 0 });

  // Set width/height based on container
  useEffect(() => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setSize({ width: rect.width, height: rect.height });
    }
  }, [containerRef.current]);

  // Stop animation after duration
  useEffect(() => {
    const timer = setTimeout(() => setIsAnimating(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <Box ref={containerRef} position="relative" w="100%" h="100%" overflow="hidden">
      {size.width > 0 && (
        <Confetti
          width={size.width}
          height={size.height}
          numberOfPieces={isAnimating ? initialPieces : frozenPieces}
          recycle={isAnimating}
        />
      )}
    </Box>
  );
};